import dayjs from 'dayjs';
import i18n from 'i18next';
import { LANGUAGE, setItemToLocalStorage } from 'shared/utils/local-storage';

export const changeLanguage = (language: string) => {
  setItemToLocalStorage(LANGUAGE, language);
  i18n.changeLanguage(language);
  dayjs.locale(language);
};
